/**
 * Locale key for the MFA cell. Null means the state is unknown: the backend could not read it
 * for this user, or the field is absent. The grid renders that as a dash rather than as Off.
 */
export const mfaLabelKey = mfaEnabled => {
  if (mfaEnabled === true) return 'general.on';
  if (mfaEnabled === false) return 'general.off';
  return null;
};